
import dayjs from 'dayjs'
import { computed, defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Button from '@/components/elements/Button.vue'
import 'dayjs/locale/ja'
dayjs.locale('ja')

export default defineComponent({
  name: 'EventButton',

  components: { Button },

  props: {
    id: {
      type: [String, Array],
      required: true
    },
    link: {
      type: String
    },
    term_end: {
      type: String,
      default: ''
    },
    entry_start: {
      type: String,
      default: ''
    },
    entry_end: {
      type: String,
      default: ''
    },
    is_subscribed: {
      type: Boolean,
      default: false
    },
    is_fixed: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const router = useRouter()
    const store = useStore()

    const eventEntryStatus = computed((): {
      label: string
      isEnable: boolean
    } => {
      // 開催期間（終了日時）が過ぎている
      if (props.term_end && dayjs().isAfter(dayjs(props.term_end))) {
        return {
          label: '終了しました',
          isEnable: false
        }
      }

      // 申し込み済みかどうか
      if (props.is_subscribed && props.is_subscribed === true) {
        return {
          label: '申込済です',
          isEnable: false
        }
      }

      // 受付期限（開始日時）が設定されていて期限前
      if (props.entry_start && dayjs().isBefore(dayjs(props.entry_start))) {
        return {
          label: '予約受付準備中',
          isEnable: false
        }
      }

      // 受付期限（終了日時）が設定されていて期限後
      if (props.entry_end && dayjs().isAfter(dayjs(props.entry_end))) {
        return {
          label: '予約受付終了',
          isEnable: false
        }
      }

      // 予約可能
      return {
        label: 'このイベントを予約する',
        isEnable: true
      }
    })

    const eventEntryLink = computed((): string => {
      // 予約不可の場合
      if (!eventEntryStatus.value.isEnable) return ''

      // リンクが設定されていたらリンクを優先
      if (props.link) return props.link

      // 予約可でリンクなしの場合
      return `/events/reserve/input/${props.id}`
    })

    const onClick = () => {
      // NOTE: Select.vueより移動。本当はDetail.vueに置きたい
      localStorage.setItem(
        'registerEvent',
        `${JSON.stringify(store.state.registerEvent)}`
      )

      router.push(eventEntryLink.value)
    }

    return {
      eventEntryStatus,
      eventEntryLink,
      onClick
    }
  }
})
